import { setupOlark } from './olark'
import { setupFullstory } from './fullstory'
import { initGa4 } from './ga'
import { sendEvent, GbAnalyticsPlugin } from './gbanalytics'

export { initAuthenticatedTracking, initUnauthenticatedTracking, sendEvent, GbAnalyticsPlugin }

/* eslint-disable camelcase */
function initAuthenticatedTracking({
  user,
  toolkit_account,
  license,
  domains,
  schools,
  enable_fullstory,
  content_access_report,
}) {
  console.info('Initializing authenticated tracking')
  setupOlark(user.name, user.email)
  if (enable_fullstory) {
    setupFullstory(user, domains, schools, toolkit_account, license)
  }

  // only set initialize google analytics if not a goalbook person
  if (
    !domains ||
    domains.length === 0 ||
    (domains.length > 0 && ['goalbookapp.com', 'Goalbook Business'].indexOf(domains[0].name) < 0)
  ) {
    // Google Analytics 4
    initGa4(process.env.VUE_APP_GA4_TOKEN)
  }
}

function initUnauthenticatedTracking({ enable_fullstory }) {
  console.info('Initializing unauthenticated tracking')
  if (enable_fullstory) {
    setupFullstory()
  }
  // Google Analytics 4
  initGa4(process.env.VUE_APP_GA4_TOKEN)
}
